import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import {Link} from 'react-router-dom';
import { IconDefinition } from './';
import { Button, CircularProgress } from '@material-ui/core'
import { ButtonProps } from '@material-ui/core/Button'

const styles = (theme: CentricTheme) => ({
  root: {
    ...theme.styles.components.button,
    textTransform: 'none'
  },
  leftIcon: {
    marginRight: theme.spacing(),
    width: theme.styles.components.icon.width,
    height: theme.styles.components.icon.height
  },
  rightIcon: {
    marginLeft: theme.spacing(),
    width: theme.styles.components.icon.width,
    height: theme.styles.components.icon.height
  },
  disabled: {
    color: '#bdbdbd !important',
    backgroundColor: 'rgba(27,27,27, 0.1) !important'
  },
  buttonLabel: {
    marginTop: -1
  },
  buttonProgress: {
    color: '#FFFFFF'
  },
  loading: {
    cursor: 'progress',
    pointerEvents: 'none'
  }
})

interface MyProps extends StyledProps, React.ButtonHTMLAttributes<HTMLElement> {
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** React component of an icon */
  icon?: IconDefinition
  component?: React.ReactType<ButtonProps>;
  /** Boolean indicating action progress */
  loading?: boolean
  color?: string;

  type?: 'submit' | 'reset' | 'button'
  fullWidth?: boolean
  href?: string
}

export class PrimaryButtonComponent extends React.PureComponent<MyProps> {
  static defaultProps = {
    disabled: false,
    loading:  false,
    onClick:  () => {},
    icon:     {position: 'right'}
    }

  render() {
    const {props, props: {classes, className, icon, children, href, loading, ...otherProps}} = this

    return (
      <Button classes={{root: classes.root, label: classNames(classes[icon && icon.component ? 'buttonLabel' : ''], {skeleton: loading}), disabled: classes.disabled}}
              component={!href ? undefined : ({...props}) => {
                const {innerRef, ...rest} = props;
                return <Link to={href} {...rest} />
              }}
              className={classNames({[classes.loading]: loading}, className)}
              variant={'contained'}
              data-type='PrimaryButton'
              color={'secondary' as any}
              {...otherProps}
              disabled={props.disabled}
              onClick={!loading ? props.onClick : () => {}}
      >
        {icon && icon.component && icon.position === 'left' ? <div className={classes.leftIcon}>{icon.component}</div> : null}
        {children}
        {icon && icon.component && icon.position === 'right' ? <div className={classes.rightIcon}>{icon.component}</div> : null}
        {loading && <CircularProgress size={24} className={`${classes.buttonProgress} ${classes.rightIcon}`}/>}
      </Button>
    )
  }
}

@(withStyles as any)(styles)
export class PrimaryButton extends PrimaryButtonComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/PrimaryButton.tsx